import { __read } from 'tslib';
import { useState, useEffect, useCallback } from 'react';
import { useEditorContext } from '../EditorContext/EditorContext.js';

var useLinkDialog = function (_a) {
    var closeDialog = _a.closeDialog;
    var editor = useEditorContext().editor;
    var _b = __read(useState(""), 2), label = _b[0], setLabel = _b[1];
    var _c = __read(useState(editor.getAttributes("link").href), 2), url = _c[0], setUrl = _c[1];
    useEffect(function () {
        // if the cursor is on a link, extend the current selection to the whole link
        editor.chain().extendMarkRange("link").run();
        var view = editor.view, state = editor.state;
        var _a = view.state.selection, from = _a.from, to = _a.to;
        var defaultLabel = state.doc.textBetween(from, to, "");
        setLabel(defaultLabel);
    }, []);
    var writeLink = useCallback(function (_a) {
        var href = _a.url, newLabel = _a.label;
        if (href) {
            var view = editor.view, state = editor.state;
            var _b = view.state.selection, from = _b.from, to = _b.to;
            var currentLabel = state.doc.textBetween(from, to, "");
            editor
                .chain()
                .focus()
                .extendMarkRange("link")
                .insertContent(newLabel || currentLabel)
                .setTextSelection({
                from: from,
                to: from + (newLabel || currentLabel).length,
            })
                .setLink({ href: href })
                .run();
        }
        closeDialog();
    }, [editor]);
    return { editor: editor, label: label, setLabel: setLabel, setUrl: setUrl, url: url, writeLink: writeLink };
};

export { useLinkDialog };
//# sourceMappingURL=useLinkDialog.js.map
